import { jsx as _jsx } from "react/jsx-runtime";
import { useParams } from 'react-router-dom';
import { Payrolls } from '../Payrolls';
import { PendingPayments } from '../PendingPayments';
export const PayrollTabs = () => {
    const { tab = 'pending' } = useParams();
    return tab === 'generated' ? _jsx(Payrolls, {}) : _jsx(PendingPayments, {});
};
